import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { DerivativeQuestionReviewType } from '../review-item';

const QUESTION_REVIEW_TYPE_TO_LABEL: Record<DerivativeQuestionReviewType, string> = {
  [DerivativeQuestionReviewType.PreScreening]: 'Pre-screening',
  [DerivativeQuestionReviewType.ExpertPrescreening]: 'Pre-screening +',
  [DerivativeQuestionReviewType.ImageReview]: 'Images',
  [DerivativeQuestionReviewType.ExpertImageReview]: 'Images +',
  [DerivativeQuestionReviewType.HumanReview]: 'Deep review',
  [DerivativeQuestionReviewType.TieBreak]: 'Tie-break',
};

const QUESTION_REVIEW_TYPE_TO_CLASS_NAME: Record<DerivativeQuestionReviewType, string> = {
  [DerivativeQuestionReviewType.PreScreening]: 'bg-sky-100 text-sky-600',
  [DerivativeQuestionReviewType.ExpertPrescreening]: 'bg-orange-100 text-orange-600',
  [DerivativeQuestionReviewType.ImageReview]: 'bg-green-100 text-green-600',
  [DerivativeQuestionReviewType.ExpertImageReview]: 'bg-purple-100 text-purple-600',
  [DerivativeQuestionReviewType.HumanReview]: 'bg-red-100 text-red-600',
  [DerivativeQuestionReviewType.TieBreak]: 'bg-yellow-100 text-yellow-600',
};

@Component({
  selector: 'dojo-question-review-type-badge',
  template: `
    @if (reviewType()) {
      <div
        [ngClass]="reviewTypeClass"
        class="inline-flex max-w-full overflow-hidden rounded-[6px] px-1.5 py-1 text-xs font-semibold"
      >
        <span class="truncate" [matTooltip]="reviewTypeLabel">{{ reviewTypeLabel }}</span>
      </div>
    }
  `,
  imports: [NgClass, MatTooltip],
})
export class QuestionReviewTypeBadgeComponent {
  readonly reviewType = input.required<DerivativeQuestionReviewType>();

  get reviewTypeClass(): string {
    return QUESTION_REVIEW_TYPE_TO_CLASS_NAME[this.reviewType()];
  }

  get reviewTypeLabel(): string {
    return QUESTION_REVIEW_TYPE_TO_LABEL[this.reviewType()];
  }
}
